/* eslint-disable @typescript-eslint/no-unused-vars */
import { Flex } from "@mantine/core";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import {
  useAccount, useWorkspaceMetricPreferences, useWorkspacePreferences,
} from "../../../../hooks/QueryHooks";
import ActiveUsers from "./components/ActiveUsers";
import TopN from "./components/TopN";
import TrendsContainer from "./components/TrendsContainer";
import useWorkspaceStore from "../../../../store/workspace/workspaceStore";
import AccountSignalsOverview from "../../../../shared/signals/AccountSignalsOverview";

const AccountOverview = () => {
  const currentWorkspace = useWorkspaceStore((state) => state.workspace);

  const params = useParams<any>();
  const account: any = useAccount({
    accountId: params.accountId || "",
    workspaceId: currentWorkspace?.id,
    enabled: params.accountId !== "" && currentWorkspace !== "",
  });

  const prefs: any = useWorkspacePreferences({
    workspaceId: currentWorkspace?.id,
    enabled: !!currentWorkspace?.id,
  });
  const metrics: any = useWorkspaceMetricPreferences({
    workspaceId: currentWorkspace?.id,
    enabled: !!currentWorkspace?.id,
  });

  const tableHeight = useMemo(
    () => (window.innerHeight * 0.35),
    [],
  );

  return (
    <Flex>
      {account?.data?.external_id && (
        <div className="w-full max-h-full self-stretch">
          {prefs.isSuccess && metrics.isSuccess
            && (
              <TrendsContainer
                prefs={prefs}
                metrics={metrics?.data?.filter((m: any) => m.linked_entity === "accounts")}
                account={account?.data}
                containerClassName="border rounded-lg"
                currentWorkspace={currentWorkspace}
              />
            )}
          <AccountSignalsOverview
            containerClass="!mt-3 border rounded-lg"
            workspace={currentWorkspace}
            accountId={account?.data?.external_id}
          />
        </div>
      )}
    </Flex>
  );
};

export default AccountOverview;
